import {
  InviteUserManagementUserBody,
  InviteUserManagementUserHeader,
} from "@project/sdk/user-management/zod";
import type {z} from "zod";
import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {userManagementUserFieldLabelIds} from "../../../messages/user-management-users.messages";

export const inviteUserManagementUserFormSchema = InviteUserManagementUserBody.extend({
  displayName: requiredStringSchema(
    InviteUserManagementUserBody.shape.displayName,
    userManagementUserFieldLabelIds.displayName,
  ),
  email: requiredStringSchema(
    InviteUserManagementUserBody.shape.email,
    userManagementUserFieldLabelIds.email,
  ),
  username: requiredStringSchema(
    InviteUserManagementUserBody.shape.username,
    userManagementUserFieldLabelIds.username,
  ),
  idempotencyKey: InviteUserManagementUserHeader.shape["Idempotency-Key"],
});
export type InviteUserManagementUserFormPayload = z.output<
  typeof inviteUserManagementUserFormSchema
>;
export const draftInviteUserManagementUserFormSchema = inviteUserManagementUserFormSchema.partial();
export type DraftInviteUserManagementUserFormPayload = z.output<
  typeof draftInviteUserManagementUserFormSchema
>;
